
import { UserCheck, ShieldCheck, ScrollText } from "lucide-react";
import ProcessCard from "./ProcessCard";

const ProviderAssessment = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <ProcessCard 
        icon={<UserCheck className="w-6 h-6 text-[#1B2F47]" />} 
        title="Expertise & Track Record" 
        content="Professional background, trading experience, and proven results of each provider are thoroughly verified." 
      />
      <ProcessCard 
        icon={<ShieldCheck className="w-6 h-6 text-[#1B2F47]" />} 
        title="Transparency & Operational Integrity" 
        content="Providers must demonstrate clear performance records with independently verifiable results." 
      />
      <ProcessCard 
        icon={<ScrollText className="w-6 h-6 text-[#1B2F47]" />} 
        title="Best Practices & Compliance" 
        content="Providers must follow recognized industry standards and respect relevant regulations." 
      />
    </div>
  );
};

export default ProviderAssessment;
